module.exports = __webpack_public_path__ + "static/CSharp-logo-6eed9079ae1b7c07153d1c9479fa3003.png";